///<reference path="../../../typings/angularjs/angular-resource.d.ts"/>
///<reference path="processEditor-module.ts"/>
module ProcessEditor {
    'use strict';

    export interface IProcessData extends ng.resource.IResource<IProcessData> {
        id: number;
        name: string;
        tagString: string;
        description: string;
        triggerData: any[];
        graphData: any;
        uniqueIdentifier: string;
        version: number;
        majorVersion: number;
        minorVersion: number;
        majorMinorVersions: IMajorMinorVersions[];
        changeDescription: string;
        isNotLatestVersion: boolean;
    }

    export interface IMajorMinorVersions {
        majorVersion: number;
        minorVersion: number;
    }

    export interface IProcessDataResource extends ng.resource.IResourceClass<IProcessData> {
    }

    export function processResourceFactory($resource: ng.resource.IResourceService, processResourceUrl: string): IProcessDataResource {
        return <IProcessDataResource> $resource(processResourceUrl, { id: "@id", name: "@name", guid: "@guid" });
    }

    app.factory("ProcessDataResource", ["$resource", "processDataResourceUrl", processResourceFactory]);
}